import { useState } from 'react';
import { Box, Fade, IconButton, Modal, Typography } from '@mui/material';
import Button from 'components/Button/Button';
import { Recipient, RecipientRole } from 'features/document/constants';
import { CloseRounded } from '@mui/icons-material';
import { docGeniusPalette } from 'styles/partials/colors';
import styles from './SendFileModal.module.css';
interface SendiFileModalProps {
  open: boolean;
  recipients: Recipient[];
  isViewMode?: boolean;
  onClose: () => void;
  onSendFile?: () => void;
}

const SendFileModal = ({ open, recipients, isViewMode, onClose, onSendFile }: SendiFileModalProps) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const handleOnClose = () => {
    onClose();
    setIsDisabled(false);
  };
  const handleOnSendFile = () => {
    setIsDisabled(true);
    if (onSendFile) onSendFile();
  };

  const handleRequiredAction = (role: RecipientRole) => {
    switch (role) {
      case RecipientRole.SIGNER:
        return 'Needs to sign';
      case RecipientRole.VIEWER:
        return 'Need to view';
      case RecipientRole.COPY:
        return 'Receives a copy';
      default:
        return '';
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Fade in={open}>
        <Box className={styles.modalContainer}>
          <Box className={styles.modalHeader}>
            {' '}
            <Typography component={'h1'} fontSize={'24px'} fontWeight={'500'} color={'#474747'} marginBottom={'32px'}>
              {isViewMode ? 'Recipients' : 'Send File'}
            </Typography>
            <IconButton aria-label='close-modal' onClick={handleOnClose}>
              <CloseRounded sx={{ color: docGeniusPalette.primaryBlue }} />
            </IconButton>
          </Box>
          <Box className={styles.modalDescription}>
            {isViewMode ? (
              <p>Here&apos;s the list of people who received the file. This information can not be modified.</p>
            ) : (
              <p>
                Here&apos;s the list of people who will get the file. Please make sure the info is right. Once the file
                is sent, you can&apos;t change it.
              </p>
            )}
          </Box>
          <Box className={styles.modalBody}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.tableHeaderName} scope='col'>
                    Full Name
                  </th>
                  <th className={styles.tableHeaderEmail} scope='col'>
                    Email Address
                  </th>
                  <th className={styles.tableHeaderRole} scope='col'>
                    Action Required
                  </th>
                </tr>
              </thead>
              <tbody className={styles.tableBody}>
                {recipients.map(({ email, fullName, role, id }) => {
                  return (
                    <tr key={id}>
                      <td className={styles.tableColumn}>{fullName}</td>
                      <td className={styles.tableColumn}>{email}</td>
                      <td className={styles.tableColumn}>{handleRequiredAction(role)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Box>
          <Box className={styles.modalFooter}>
            <Button className={styles.secondaryBtn} variant='secondary' onClick={handleOnClose}>
              Cancel
            </Button>
            {!isViewMode && (
              <Button className={styles.primaryBtn} disabled={isDisabled} variant='primary' onClick={handleOnSendFile}>
                Send File
              </Button>
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SendFileModal;
